import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/Motivos.css';

const nombresEstrellas = [
  "Carmen", "Daniela", "Blanca", "Clara", "Ishaq", "Andrés", "Hugo", 
  "Diego", "Martín", "Serafín", "Elena", "Nora", "Marcos", "Pablo", 
  "Cristina", "Ángel", "Sheila", "Miriam", "Plerina", "Sara Sofía", "Elena"
];

const Motivos = () => {
  const [activeNames, setActiveNames] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      const nuevoNombre = {
        id: Date.now(),
        texto: nombresEstrellas[Math.floor(Math.random() * nombresEstrellas.length)],
        angle: Math.random() * 360,
      };
      setActiveNames((prev) => [...prev.slice(-12), nuevoNombre]);
    }, 900);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="objetivo-container">
      <div className="bloque-narrativo-unificado">
        <p className="texto-fluido">
          Nuestras <span className="highlight-inline">razones para pedalear</span> nacen de la convicción de que 
          cada kilómetro recorrido es una oportunidad para cambiar realidades. Este desafío, que une 
          Disneyland Paris con Higueruela, es un motor de superación y memoria que busca transformar 
          el esfuerzo físico en un mensaje de esperanza compartido por todos los que creen en la magia 
          de la solidaridad.
        </p>

        <p className="texto-fluido">
          Todo este trayecto tiene un <span className="highlight-inline">objetivo solidario</span> muy claro: 
          apoyar íntegramente a la <strong>Fundación Pequeño Deseo</strong>. Trabajamos juntos para 
          cumplir los deseos de niños y niñas con enfermedades graves, regalándoles la fuerza y la 
          sonrisa que necesitan para seguir luchando, porque a veces, el mejor tratamiento es la alegría.
        </p>
      </div>

      <div className="bicicleta-canvas">
        <img 
          src="https://firebasestorage.googleapis.com/v0/b/elretodecarmen-3a0ae.firebasestorage.app/o/imagenes%20presentaci%C3%B3n%2F04.png?alt=media&token=be8274e9-24dc-405f-935b-609eac1ef9b3" 
          alt="Constelación de sonrisas" 
          className="img-bicicleta"
        />
        <div className="nombres-overlay">
          {activeNames.map((n) => (
            <span key={n.id} className="nombre-flotante" style={{ '--angle': `${n.angle}deg` }}>
              {n.texto}
            </span>
          ))}
        </div>
      </div>

      <div className="button-section">
        <button className="btn-colabora" onClick={() => navigate('/colabora')}>
          ¡Quiero colaborar!
        </button>
      </div>
    </div>
  );
};

export default Motivos;